"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeasonWithProduct = exports.GetPaginatedEventsQueryDto = exports.GetPaginatedSegmentsQueryDto = exports.GetPaginatedSessionQueryDto = exports.GetRelatedProgramSessionsDto = exports.RelatedSessionsDto = exports.GetOrganizationProgramSessionsDto = exports.NotifySessionAttendeesDto = exports.NotifyEventAttendeesDto = exports.EventsAndConflictsDto = exports.UpdateProgramSeasonOptionsDto = exports.UpdateProgramSeasonColorsDto = exports.MoveParticipantDto = exports.UpdateSeasonRegistrationDatesDto = exports.MoveAttendeeDto = exports.UpdateSeasonDatesDto = exports.SpaceAllocationsByTimesDto = exports.SingleSpaceAllocationByTimesDto = exports.BulkSpaceResourceAllocationDto = exports.SpaceResourcePairDto = exports.SimpleSessionDto = exports.ShallowUpdateSubSeasonDto = exports.ShallowUpdateProgramSeasonDto = exports.UpdateProgramSeasonStatusDto = exports.UpdateProgramSeasonDto = exports.CreateProgramSeasonDto = exports.SubSeasonBasicInfo = exports.CreateSessionScheduleDto = exports.BaseProgramSeasonDto = exports.RegistrationSettingsDto = exports.RegistrationDatesDto = exports.BlockedDatesDto = exports.FindRegisteredUsersOptionsDto = exports.FindRegisteredUserDto = exports.DeleteProductDto = exports.FindSessionEventByIdDto = exports.ByOrganizationIdAndProgramSeasonIdDto = exports.FindSeasonEventsQueryDto = exports.SegmentsBySessionQueryDto = exports.FindProgramSeasonByIdDto = exports.FindProgramSeasonByIdQueryDto = exports.DeleteEventAttendeesDto = exports.BySeasonDto = exports.FindSessionsFiltersDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const backoffice_notify_dto_1 = require("../../notifications/dto/backoffice.notify.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
const program_dto_1 = require("../../programs/dto/program.dto");
class FindSessionsFiltersDto {
}
exports.FindSessionsFiltersDto = FindSessionsFiltersDto;
class BySeasonDto extends program_dto_1.ByProgramDto {
}
exports.BySeasonDto = BySeasonDto;
class DeleteEventAttendeesDto {
}
exports.DeleteEventAttendeesDto = DeleteEventAttendeesDto;
class FindProgramSeasonByIdQueryDto {
}
exports.FindProgramSeasonByIdQueryDto = FindProgramSeasonByIdQueryDto;
class FindProgramSeasonByIdDto extends organization_dto_1.OptionalOrganizationIdDto {
}
exports.FindProgramSeasonByIdDto = FindProgramSeasonByIdDto;
class SegmentsBySessionQueryDto {
}
exports.SegmentsBySessionQueryDto = SegmentsBySessionQueryDto;
class FindSeasonEventsQueryDto extends general_dto_1.PaginationQuery {
}
exports.FindSeasonEventsQueryDto = FindSeasonEventsQueryDto;
class ByOrganizationIdAndProgramSeasonIdDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByOrganizationIdAndProgramSeasonIdDto = ByOrganizationIdAndProgramSeasonIdDto;
class FindSessionEventByIdDto {
}
exports.FindSessionEventByIdDto = FindSessionEventByIdDto;
class DeleteProductDto {
}
exports.DeleteProductDto = DeleteProductDto;
class FindRegisteredUserDto extends FindProgramSeasonByIdDto {
}
exports.FindRegisteredUserDto = FindRegisteredUserDto;
class FindRegisteredUsersOptionsDto extends general_dto_1.PaginationQuery {
}
exports.FindRegisteredUsersOptionsDto = FindRegisteredUsersOptionsDto;
class BlockedDatesDto {
}
exports.BlockedDatesDto = BlockedDatesDto;
class RegistrationDatesDto {
}
exports.RegistrationDatesDto = RegistrationDatesDto;
class RegistrationSettingsDto extends RegistrationDatesDto {
}
exports.RegistrationSettingsDto = RegistrationSettingsDto;
class BaseProgramSeasonDto extends RegistrationSettingsDto {
}
exports.BaseProgramSeasonDto = BaseProgramSeasonDto;
class CreateSessionScheduleDto {
}
exports.CreateSessionScheduleDto = CreateSessionScheduleDto;
class SubSeasonBasicInfo {
}
exports.SubSeasonBasicInfo = SubSeasonBasicInfo;
class CreateProgramSeasonDto extends BaseProgramSeasonDto {
}
exports.CreateProgramSeasonDto = CreateProgramSeasonDto;
class UpdateProgramSeasonDto extends BaseProgramSeasonDto {
}
exports.UpdateProgramSeasonDto = UpdateProgramSeasonDto;
class UpdateProgramSeasonStatusDto {
}
exports.UpdateProgramSeasonStatusDto = UpdateProgramSeasonStatusDto;
class ShallowUpdateProgramSeasonDto {
}
exports.ShallowUpdateProgramSeasonDto = ShallowUpdateProgramSeasonDto;
class ShallowUpdateSubSeasonDto extends general_dto_1.IdAndNameDto {
}
exports.ShallowUpdateSubSeasonDto = ShallowUpdateSubSeasonDto;
class SimpleSessionDto extends general_dto_1.IdAndNameDto {
}
exports.SimpleSessionDto = SimpleSessionDto;
class SpaceResourcePairDto {
}
exports.SpaceResourcePairDto = SpaceResourcePairDto;
class BulkSpaceResourceAllocationDto {
}
exports.BulkSpaceResourceAllocationDto = BulkSpaceResourceAllocationDto;
class SingleSpaceAllocationByTimesDto {
}
exports.SingleSpaceAllocationByTimesDto = SingleSpaceAllocationByTimesDto;
class SpaceAllocationsByTimesDto {
}
exports.SpaceAllocationsByTimesDto = SpaceAllocationsByTimesDto;
class UpdateSeasonDatesDto {
}
exports.UpdateSeasonDatesDto = UpdateSeasonDatesDto;
class MoveAttendeeDto {
}
exports.MoveAttendeeDto = MoveAttendeeDto;
class UpdateSeasonRegistrationDatesDto {
}
exports.UpdateSeasonRegistrationDatesDto = UpdateSeasonRegistrationDatesDto;
class MoveParticipantDto {
}
exports.MoveParticipantDto = MoveParticipantDto;
class UpdateProgramSeasonColorsDto {
}
exports.UpdateProgramSeasonColorsDto = UpdateProgramSeasonColorsDto;
class UpdateProgramSeasonOptionsDto extends program_dto_1.UpdateProgramOptionsDto {
}
exports.UpdateProgramSeasonOptionsDto = UpdateProgramSeasonOptionsDto;
class EventsAndConflictsDto {
}
exports.EventsAndConflictsDto = EventsAndConflictsDto;
/*
 * Notify Attendees within multiple Events of a single Session.
 */
class NotifyEventAttendeesDto extends backoffice_notify_dto_1.BaseNotificationDto {
}
exports.NotifyEventAttendeesDto = NotifyEventAttendeesDto;
/*
 * Notify Attendees within multiple Sessions of a single Program.
 */
class NotifySessionAttendeesDto extends backoffice_notify_dto_1.BaseNotificationDto {
}
exports.NotifySessionAttendeesDto = NotifySessionAttendeesDto;
class GetOrganizationProgramSessionsDto extends general_dto_1.PaginationQuery {
}
exports.GetOrganizationProgramSessionsDto = GetOrganizationProgramSessionsDto;
class RelatedSessionsDto {
}
exports.RelatedSessionsDto = RelatedSessionsDto;
class GetRelatedProgramSessionsDto {
}
exports.GetRelatedProgramSessionsDto = GetRelatedProgramSessionsDto;
class GetPaginatedSessionQueryDto extends general_dto_1.PaginationQuery {
}
exports.GetPaginatedSessionQueryDto = GetPaginatedSessionQueryDto;
class GetPaginatedSegmentsQueryDto extends GetPaginatedSessionQueryDto {
}
exports.GetPaginatedSegmentsQueryDto = GetPaginatedSegmentsQueryDto;
class GetPaginatedEventsQueryDto extends GetPaginatedSessionQueryDto {
}
exports.GetPaginatedEventsQueryDto = GetPaginatedEventsQueryDto;
class SeasonWithProduct {
}
exports.SeasonWithProduct = SeasonWithProduct;
//# sourceMappingURL=program-seasons.dto.js.map